import axios, { AxiosError } from "axios"
import { RootState } from "../"
import { logout, refreshAccessToken } from "../actions/auth"

export const setInterceptors = (store: RootState) => {
	if (!store) {
		return
	}

	// is refresh token request called yet
	let isRefreshing = false
	let failedQueue: {
		resolve: (token: string) => void
		reject: (error: AxiosError) => void
	}[] = [] // to retry after refresh

	const processQueue = (error: AxiosError | null) => {
		for (const prom of failedQueue) {
			if (error) {
				prom.reject(error)
			} else {
				prom.resolve()
			}
		}

		failedQueue = []
	}
	axios.interceptors.response.use(
		(response) => response,
		async (error: AxiosError) => {
			const originalRequest = error.config as any

			if (
				store.getState().auth?.isAuthenticate &&
				error.response?.status === 401 &&
				!originalRequest._retry
			) {
				originalRequest._retry = true

				if (isRefreshing) {
					return new Promise((resolve, reject) => {
						failedQueue.push({ resolve, reject })
					})
						.then(() => axios(originalRequest))
						.catch((err) => Promise.reject(err))
				}

				isRefreshing = true
				try {
					const { newtoken } = await store.dispatch(refreshAccessToken())
					processQueue(null)
					return axios(originalRequest)
				} catch (e) {
					processQueue(e as AxiosError)
					store.dispatch(logout())
					return Promise.reject(e)
				} finally {
					isRefreshing = false
				}
			}

			// 👇 Log utile per capire cosa stai buttando via
			console.log("Interceptor caught error:", {
				status: error.response?.status,
				data: error.response?.data,
				headers: error.response?.headers,
			})

			return Promise.reject(error)
		}
	)

	axios.interceptors.request.use(
		(config) => {
			return config
		},
		(error) => {
			console.log("***** ERROR REq: " + JSON.stringify(error))
			return Promise.reject(error)
		}
	)
}

export const axiosMiddleware = (store) => {
	setInterceptors(store)
}
